 (function () {
  'use strict';

  var roots = document.querySelectorAll('[data-jamu-ing]');

  roots.forEach(function (root) {
    // Guard: Shopify's theme editor can re-render a section (and re-run this
    // script) without a full page reload when you tweak a setting. Without
    // this guard, a second click listener gets bound on top of the first —
    // which made the accordion look like it "opened then instantly closed",
    // since the first listener's click was immediately followed by the
    // second listener treating it as already-open and closing it.
    if (root.hasAttribute('data-jamu-bound')) return;
    root.setAttribute('data-jamu-bound', 'true');

    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-jamu-trigger]'));
    var galleryItems = Array.prototype.slice.call(root.querySelectorAll('[data-jamu-jump]'));
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-jamu-row]'));

    function triggerFor(index) {
      return root.querySelector('[data-jamu-trigger="' + index + '"]');
    }
    function panelFor(index) {
      return root.querySelector('[data-jamu-panel="' + index + '"]');
    }

    function closeAll() {
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      root.querySelectorAll('[data-jamu-panel]').forEach(function (p) {
        p.classList.remove('is-open');
        p.setAttribute('aria-hidden', 'true');
      });
      galleryItems.forEach(function (g) { g.classList.remove('is-active'); });
    }

    function openIndex(index) {
      var trigger = triggerFor(index);
      var panel = panelFor(index);
      if (!trigger || !panel) return;
      trigger.setAttribute('aria-expanded', 'true');
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      galleryItems.forEach(function (g) {
        g.classList.toggle('is-active', g.getAttribute('data-jamu-jump') === String(index));
      });
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var index = trigger.getAttribute('data-jamu-trigger');
        var wasOpen = trigger.getAttribute('aria-expanded') === 'true';
        closeAll();
        if (!wasOpen) openIndex(index);
      });
    });

    galleryItems.forEach(function (item) {
      item.addEventListener('click', function () {
        var index = item.getAttribute('data-jamu-jump');
        var trigger = triggerFor(index);
        var wasOpen = trigger && trigger.getAttribute('aria-expanded') === 'true';
        closeAll();
        if (!wasOpen) openIndex(index);
        var row = root.querySelector('[data-jamu-row="' + index + '"]');
        if (row) {
          var offset = row.getBoundingClientRect().top + window.pageYOffset - 96;
          window.scrollTo({ top: offset, behavior: 'smooth' });
        }
      });
    });

    // Gentle scroll-reveal for rows
    if ('IntersectionObserver' in window) {
      rows.forEach(function (row) { row.setAttribute('data-reveal', 'pending'); });
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.setAttribute('data-reveal', 'done');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      rows.forEach(function (row) { observer.observe(row); });
    }
  });
})();
